import dynamic from "next/dynamic";

export const DynamicLayoutWidget079 = dynamic(
  () => import("./LayoutWidget079"),
  {
    suspense: true,
  }
);
